<template>
  <section class="c-feature">
    <div class="c-heading">
      <h1 class="c-heading__title primary-title padding-b-none">
        {{ locationName }}
      </h1>
      <div
        class="c-feature-location__store-name highlighted"
        v-if="location.c_infoBanner && location.c_infoBanner.length >= 3"
      >
        <p style="margin-bottom:10px;">
          <span class="highlighted">{{ decoder(location.c_infoBanner) }}</span>
        </p>
      </div>
      <div class="c-feature-location__store-name">
        <p>{{ decoder(location.c_shortDescription) }}</p>
      </div>
      <div class="location-detail-header">
        <a
          class="c-cta c-cta--orange-outline"
          :href="location.orderUrl"
          aria-label="Order online"
          v-if="location.orderUrl"
          ><img
            class="button-icon"
            :src="`${assetPath}images/icons/wing-icon.svg`"
            alt="Order online icon"
          />
          <span>ORDER ONLINE</span>
        </a>
        <a
          class="c-cta c-cta--orange-outline"
          :href="location.c_cateringURL"
          aria-label="Order online"
          v-if="location.c_cateringURL"
        >
          <img
            class="button-icon circle-icon"
            :src="`${assetPath}images/icons/catering-icon.svg`"
            alt="Get catering icon"
          />
          <span>get catering</span>
        </a>
      </div>
    </div>
    <hr />
    <div class="location-details-wrapper">
      <DetailPane :location="location" :mapUrl="mapUrl" />
      <HighlightsPane :location="location" />
    </div>
  </section>
</template>

<script>
import locationPanelToggle from '../../../../components/locationPanel';
import DetailPane from '@/components/location/DetailPane';
import HighlightsPane from '@/components/location/HighlightsPane';
import { store } from '@/store';
import fetchLocations from '../services/fetchLocation';
// import locations from '@/locations';
export default {
  name: 'App',
  components: { DetailPane, HighlightsPane },
  data() {
    return {
      favoriteLocation: null,
      userPos: null,
      slug: this.$route.params.slug,
      assetPath: store.assetPath(),
      perchPath: store.perchPath(),
      location: null,
    };
  },
  async mounted() {
    const location = await fetchLocations(this.$route.params.slug);

    // const location = JSON.parse(
    //   document.getElementById('locationDataFromApi').dataset.locations
    // );
    if (location.length) {
      const singleLocation = location.find(
        loc => loc.c_locationSlug.toLowerCase() === this.slug
      );
      Object.keys(singleLocation).map(val => {
        if (singleLocation[val] && typeof singleLocation[val] === 'string') {
          if (
            singleLocation[val].includes('{') ||
            singleLocation[val].includes('["')
          )
            try {
              singleLocation[val] = JSON.parse(singleLocation[val]);
            } catch (error) {
              console.error('Unable to convert string to object');
            }
        }
      });
      this.location = singleLocation;
    } else {
      Object.keys(location).map(val => {
        if (location[val] && typeof location[val] === 'string') {
          if (location[val].includes('{') || location[val].includes('["'))
            try {
              location[val] = JSON.parse(location[val]);
            } catch (error) {
              console.error('Unable to convert string to object');
            }
        }
      });
      this.location = location;
    }
  },
  methods: {
    decoder(str) {
      var textArea = document.createElement('textarea');
      textArea.innerHTML = str;
      return textArea.value;
    },
    getLocationName(name) {
      if (name.toLowerCase().includes('hoots wings -')) {
        return name.toLowerCase().replace(/hoots wings - /, '');
      } else {
        return location.name.toLowerCase();
      }
    },
    mapUrl: function (location) {
      if (location.c_mapUrl) {
        return location.c_mapUrl;
      }
      return `https://www.google.com/maps/place/${encodeURI(
        location.address['line1']
      )},+${location.address.city},+${location.address.region}+${location.address.postalCode
        }/@${location.geocodedCoordinate.latitude},${location.geocodedCoordinate.longitude
        },17z/data=!3m1!4b1!4m5!3m4!1s0x88f507772a1fb279:0xbcf04321c3c4cc19!8m2!3d33.7931182!4d-84.2829744`;
    },
    setFavorite(location) {
      localStorage.favoriteLocation = JSON.stringify(location);
      this.favoriteLocation = location;
      locationPanelToggle(location);
    },

    calculateDistance(lat1, lon1, lat2, lon2) {
      let deg2rad = this.deg2rad;
      var R = 6371;
      var dLat = deg2rad(lat2 - lat1);
      var dLon = deg2rad(lon2 - lon1);
      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(deg2rad(lat1)) *
        Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      var d = R * c;
      return d;
    },
    deg2rad(deg) {
      return deg * (Math.PI / 180);
    },
    calculateDistances(data, origin) {
      const stores = [];
      const destinations = [];
      data.forEach(store => {
        store.distance = Math.floor(
          this.calculateDistance(
            store.geocodedCoordinate.latitude,
            store.geocodedCoordinate.longitude,
            origin[0],
            origin[1]
          )
        );

        stores.push(store);
        destinations.push(store);
        stores.sort(function (a, b) {
          if (a.distance > b.distance) {
            return 1;
          }
          if (a.distance < b.distance) {
            return -1;
          }
          return 0;
        });
        //Ensure that we only show stores in the same country.
        this.storeList = stores.filter(
          store => store.country === stores[0].country && store.distance <= 50
        );
      });
    },
  },
  computed: {
    locationName() {
      if (this.location) {
        const backgroundImage =
          this.location.locationDynamicFields && this.location.locationDynamicFields.c_mastheadPerch != null
            ? `/perch/resources/${this.location.locationDynamicFields.c_mastheadPerch.path}`
            : '/perch/resources/mastheads/hootsmastheadchooseyourthing.jpg';
        document.querySelectorAll(
          '.c-masthead__cover'
        )[0].style.backgroundImage = `url(${backgroundImage})`;
        document.querySelectorAll(
          '.c-masthead__cover'
        )[1].style.backgroundImage = `url(${backgroundImage})`;

        return this.location.name.toLowerCase();
      }
    },
    // location() {
    //   return locations.find((loc) => loc.c_locationSlug === this.slug);
    // },
  },
};
</script>
